<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex shrink>
        <v-btn color="grey" outline :loading="isExporting" class="ma-0" @click="exportToFile()">
          <v-icon left>ios_share</v-icon>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card class="mt-3">
      <v-card-text>
        <v-container grid-list-md class="pa-0 ma-0" :style="{ width: '100% !important' }">
          <v-layout wrap align-center>
            <v-flex :xs12="$vuetify.breakpoint.xsOnly">{{ $t('number_of_respondents') }}</v-flex>
            <v-flex :xs12="$vuetify.breakpoint.xsOnly" shrink class="primary--text headline">
              <v-progress-circular v-if="isLoading" :size="24" indeterminate color="primary" />
              <TweenNum
                v-else
                :value="total"
                :initial="0"
                :formatter="$options.filters.numberFormat"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>

    <div
      v-if="isLoading"
      class="d-flex pa-3"
      :style="{ height: '200px', justifyContent: 'center', alignItems: 'center' }"
    >
      <v-progress-circular indeterminate color="primary" />
    </div>
    <SurveySummaryTable v-else class="mt-3" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import TweenNum from 'vue-tween-number'
import { mapGetters } from 'vuex'
import surveyApi from '@/api/survey'
import SurveySummaryTable from './SurveySummaryTable.vue'

export default {
  components: { TweenNum, SurveySummaryTable },
  inject: ['surveyId'],
  provide() {
    return {
      parts: () => this.parts,
      viewedChoice: () => this.viewedChoice,
      setViewedChoice: (value) => (this.viewedChoice = value)
    }
  },
  data() {
    return {
      isLoading: false,
      parts: null,
      total: 0,
      viewedChoice: null,
      isExporting: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.fetchSurveySummary()
  },
  methods: {
    async fetchSurveySummary() {
      try {
        this.isLoading = true

        const response = await surveyApi.getSummary({
          params: {
            page_id: this.selectedBot.pageid,
            survey_id: this.surveyId()
          }
        })

        if (response.status === 200) {
          this.parts = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async exportToFile() {
      try {
        this.isExporting = true

        const response = await surveyApi.getSummary({
          params: {
            page_id: this.selectedBot.pageid,
            survey_id: this.surveyId()
          }
        })

        if (response.status === 200 && response.data.data) {
          const rows = response.data.data
            .map((part, partIndex) => [
              ...(partIndex !== 0 ? [['']] : []),
              [part.part],
              ['', 'คำถาม', 'ผลประเมิน', 'คะแนนรวม'],
              ...part.question_list
                .map((question, questionIndex) => [
                  [
                    `Q${questionIndex + 1}`,
                    question.question,
                    ...(question.type === 'text'
                      ? ['', '', question.choices[0].answers.join(', ')]
                      : [])
                  ],
                  ...question.choices.map((choice) =>
                    question.type !== 'text'
                      ? [
                          '',
                          choice.text,
                          choice.score.toString(),
                          `${choice.percent}%`,
                          choice.answers.join(', ')
                        ]
                      : []
                  )
                ])
                .flat()
            ])
            .flat()

          const worksheet = XLSX.utils.aoa_to_sheet(rows)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Survey Summary')
          XLSX.writeFile(workbook, `survey-summary-${Date.now()}.xlsx`)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveySummary/SurveySummary.vue